<template>
  <div
    class="container"
    :class="screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'"
  >
    <div class="columns is-centered mx-auto container_width">
      <div class="column is-8">
        <div class="card is-multiline is-mobile">
          <header class="card-header">
            <div
              class="column is-12 has-padding-left-30-desktop has-padding-right-30-desktop is-hidden-mobile"
            >
              <div
                class="columns is-multiline is-mobile is-vcentered is-desktop"
              >
                <div class="column is-11">
                  <div class="has-text-weight-bold is-size-6">
                    {{ $t('Preview Job Post') }}
                  </div>
                  <div class="is-size-7 has-text-grey">
                    {{ $t('Preview your job post') }}
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div class="section card-content pt-0 pb-0 mt-0">
            <div class="columns is-vcentered is-multiline is-mobile mt-1">
              <div class="columns is-mobile mt-1">
                <div class="column is-5-desktop is-5-mobile">
                  <img
                    :src="$auth.user.profile_picture"
                    class="is-full-height image is-96x96"
                  />
                </div>
                <div class="column is-7-desktop is-7-mobile">
                  <div class="is-size-5 has-text-weight-bold">
                    {{ fetchedJobDetails.job_title || '' }}
                  </div>
                  <div class="has-text-grey is-size-8">
                    {{
                      (fetchedJobDetails && fetchedJobDetails.org_alt_name) ||
                      ($auth.user.related_organizations &&
                        $auth.user.related_organizations[0].name)
                    }}
                  </div>
                </div>
              </div>
              <div class="column is-12 py-0"><hr class="my-1" /></div>
              <div :class="isShowDetail == true ? 'is-hidden-mobile' : ''">
                <div class="column is-12">
                  <div class="columns is-multiline">
                    <div
                      v-if="
                        fetchedJobDetails &&
                        fetchedJobDetails.job_locations &&
                        fetchedJobDetails.job_locations[0].address
                      "
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-map-marker')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('jobLocation')"
                          ></div>
                          <div class="is-size-8 has-text-weight-bold">
                            {{
                              fetchedJobDetails &&
                              fetchedJobDetails.job_locations &&
                              fetchedJobDetails.job_locations[0].address
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="fetchedJobDetails.offered_salary"
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-money-bill')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Offered Salary')"
                          ></div>
                          <div class="is-size-8 has-text-weight-bold">
                            {{
                              `${
                                fetchedJobDetails.offered_salary &&
                                fetchedJobDetails.offered_salary.currency
                              }. ${
                                fetchedJobDetails.offered_salary &&
                                fetchedJobDetails.offered_salary.minimum
                              }${
                                fetchedJobDetails.offered_salary &&
                                fetchedJobDetails.offered_salary.maximum
                                  ? '-' +
                                    fetchedJobDetails.offered_salary.maximum
                                  : ''
                              } ${
                                fetchedJobDetails.offered_salary &&
                                fetchedJobDetails.offered_salary.unit
                              }`
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="fetchedJobDetails.vacancies" class="column is-6">
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-users-alt')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('No of Vacancies')"
                          ></div>
                          <div class="is-size-8 has-text-weight-bold">
                            {{ fetchedJobDetails.vacancies }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="fetchedJobDetails.preferred_shift"
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-clock')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Shift')"
                          ></div>
                          <div class="is-size-8 has-text-weight-bold">
                            {{
                              $t(
                                $options.getNameByValue(
                                  $options.preferredShitChoices,
                                  fetchedJobDetails.preferred_shift
                                )
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="fetchedJobDetails.available_for"
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-file-check')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Job Type')"
                          ></div>
                          <div class="is-size-8 has-text-weight-bold">
                            {{
                              fetchedJobDetails.available_for &&
                              $t(
                                $options.getNameByValue(
                                  $options.availableForChoices,
                                  fetchedJobDetails.available_for[0]
                                )
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="fetchedJobDetails.job_level" class="column is-6">
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-sitemap')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Job Level')"
                          ></div>
                          <div class="is-size-8 has-text-weight-bold">
                            {{
                              $t(
                                $options.getNameByValue(
                                  $options.jobLevelChoices,
                                  fetchedJobDetails.job_level
                                )
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-12 py-0"><hr class="my-1" /></div>
                <div class="column is-12">
                  <div class="columns is-multiline">
                    <div
                      v-if="
                        fetchedJobDetails.education_level ||
                        !fetchedJobDetails.is_education_specific
                      "
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-book-open')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Education')"
                          ></div>
                          <div
                            v-if="fetchedJobDetails.education_level"
                            class="has-text-weight-bold is-size-8"
                          >
                            <span>{{
                              fetchedJobDetails.education_level &&
                              fetchedJobDetails.education_level.name
                            }}</span>
                            <span
                              v-if="fetchedJobDetails.is_education_specific"
                              class="has-text-weight-normal is-size-7"
                              >({{ $t('Required') }})</span
                            >
                            <span
                              v-if="
                                fetchedJobDetails.education_level &&
                                !fetchedJobDetails.is_education_specific
                              "
                              class="has-text-weight-normal is-size-7"
                              >({{ $t('preferred') }})</span
                            >
                          </div>
                          <div v-else class="has-text-weight-bold is-size-8">
                            <span>{{ $t('Not Required') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="fetchedJobDetails.setting" class="column is-6">
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-briefcase')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Work Experience')"
                          ></div>
                          <div
                            v-if="
                              fetchedJobDetails.setting &&
                              fetchedJobDetails.setting.min_experience_months
                            "
                            class="has-text-weight-bold is-size-8"
                          >
                            <span>
                              {{
                                `${
                                  fetchedJobDetails.setting &&
                                  fetchedJobDetails.setting
                                    .min_experience_months / 12
                                } ${$t('Year')}`
                              }}
                            </span>
                            <span
                              v-if="
                                fetchedJobDetails.setting &&
                                fetchedJobDetails.setting.is_experience_required
                              "
                              class="has-text-weight-normal is-size-7"
                              >({{ $t('Required') }})</span
                            >
                            <span
                              v-if="
                                fetchedJobDetails.setting &&
                                fetchedJobDetails.setting
                                  .min_experience_months &&
                                !fetchedJobDetails.setting
                                  .is_experience_required
                              "
                              class="has-text-weight-normal is-size-7"
                              >({{ $t('preferred') }})</span
                            >
                          </div>
                          <div
                            v-if="
                              fetchedJobDetails.setting &&
                              !fetchedJobDetails.setting.min_experience_months
                            "
                            class="has-text-weight-bold is-size-8"
                          >
                            <span>{{ $t('Not Required') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="fetchedJobDetails.setting" class="column is-6">
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-mars')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Gender')"
                          ></div>
                          <div
                            v-if="
                              fetchedJobDetails.setting &&
                              fetchedJobDetails.setting.gender
                            "
                            class="has-text-weight-bold is-size-8"
                          >
                            <span>
                              {{
                                $t(
                                  fetchedJobDetails.setting &&
                                    fetchedJobDetails.setting.gender
                                )
                              }}
                            </span>
                            <span
                              v-if="
                                fetchedJobDetails.setting &&
                                fetchedJobDetails.setting.is_gender_specific
                              "
                              class="has-text-weight-normal is-size-7"
                              >({{ $t('Required') }})</span
                            >
                            <span
                              v-if="
                                fetchedJobDetails.setting &&
                                fetchedJobDetails.setting.gender &&
                                !fetchedJobDetails.setting.is_gender_specific
                              "
                              class="has-text-weight-normal is-size-7"
                              >({{ $t('preferred') }})</span
                            >
                          </div>
                          <div
                            v-if="
                              fetchedJobDetails.setting &&
                              !fetchedJobDetails.setting.gender
                            "
                            class="has-text-weight-bold is-size-8"
                          >
                            <span>{{ $t('No Preference') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="fetchedJobDetails.setting" class="column is-6">
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-calender')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Age')"
                          ></div>
                          <div
                            v-if="
                              fetchedJobDetails.setting &&
                              (fetchedJobDetails.setting.min_age ||
                                fetchedJobDetails.setting.max_age)
                            "
                            class="has-text-weight-bold is-size-8"
                          >
                            <span
                              v-if="get(fetchedJobDetails, 'setting.min_age')"
                            >
                              {{
                                $t('aboveAge', [
                                  fetchedJobDetails.setting.min_age + $t('Year')
                                ])
                              }}</span
                            >
                            <span
                              v-if="get(fetchedJobDetails, 'setting.max_age')"
                              >{{
                                $t('belowAge', [
                                  fetchedJobDetails.setting.max_age + $t('Year')
                                ])
                              }}</span
                            >
                          </div>
                          <div
                            v-if="
                              fetchedJobDetails.setting &&
                              !fetchedJobDetails.setting.min_age &&
                              !fetchedJobDetails.setting.max_age
                            "
                            class="has-text-weight-bold is-size-8"
                          >
                            <span>{{ $t('No Preference') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="fetchedJobDetails.deadline" class="column is-6">
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-calender')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Deadline')"
                          ></div>
                          <div class="has-text-weight-bold is-size-8">
                            {{
                              fetchedJobDetails.deadline.substring(0, 10) +
                              ' ' +
                              fetchedJobDetails.deadline.substring(11, 19)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        fetchedJobDetails.skills &&
                        fetchedJobDetails.skills.length
                      "
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-science')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="is-size-7 has-text-grey"
                            v-text="$t('Skills')"
                          ></div>
                          <div class="has-text-weight-bold is-size-8">
                            <span
                              v-for="(skill, index) in fetchedJobDetails.skills"
                              :key="index"
                            >
                              {{ $t(skill.name) }},
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        fetchedJobDetails.personal_qualities &&
                        fetchedJobDetails.personal_qualities.length
                      "
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-user-circle')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="is-size-7 has-text-grey"
                            v-text="$t('Personal Quality')"
                          ></div>
                          <div class="has-text-weight-bold is-size-8">
                            <span
                              v-for="(personalQuality,
                              index) in fetchedJobDetails.personal_qualities"
                              :key="index"
                            >
                              {{ $t(personalQuality.name) }},
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        fetchedJobDetails.required_knowledge &&
                        fetchedJobDetails.required_knowledge.length
                      "
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-book-reader')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="is-size-7 has-text-grey"
                            v-text="$t('Required Knowledge')"
                          ></div>
                          <div class="has-text-weight-bold is-size-8">
                            <span
                              v-for="(requiredKnowledge,
                              index) in fetchedJobDetails.required_knowledge"
                              :key="index"
                            >
                              {{ $t(requiredKnowledge.name) }},
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        fetchedJobDetails.work_standards &&
                        fetchedJobDetails.work_standards.length
                      "
                      class="column is-6"
                    >
                      <div
                        class="columns has-text-left is-vcentered pa-0 is-mobile"
                      >
                        <div class="column is-1 is-size-5 mr-2">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-bag')]"
                          >
                          </vue-icon-base>
                        </div>
                        <div class="column">
                          <div
                            class="has-text-grey is-size-7"
                            v-text="$t('Work Standards')"
                          ></div>
                          <div class="has-text-weight-bold is-size-8">
                            <span
                              v-for="(workStandard,
                              index) in fetchedJobDetails.work_standards"
                              :key="index"
                            >
                              {{ $t(workStandard.name) }},
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-12 py-0"><hr class="my-1" /></div>
                <div
                  v-if="
                    fetchedJobDetails.benefits &&
                    fetchedJobDetails.benefits.length
                  "
                  class="column is-6"
                >
                  <div
                    class="columns has-text-left is-vcentered pa-0 is-mobile"
                  >
                    <div class="column is-1 is-size-5 mr-2">
                      <vue-icon-base
                        height="16"
                        width="16"
                        :path="$options.icons[$kc('uni-smile-beam')]"
                      >
                      </vue-icon-base>
                    </div>
                    <div class="column">
                      <div
                        class="is-size-7 has-text-grey"
                        v-text="$t('Benefits')"
                      ></div>
                      <div class="is-size-8 has-text-weight-bold">
                        <span
                          v-for="(benefit, index) in fetchedJobDetails.benefits"
                          :key="index"
                        >
                          {{ benefit.name }},
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fetchedJobDetails.setting" class="column is-6">
                  <div
                    class="columns has-text-left is-vcentered pa-0 is-mobile"
                  >
                    <div class="column is-1 is-size-5 mr-2">
                      <vue-icon-base
                        height="16"
                        width="16"
                        :path="$options.icons[$kc('uni-bus-alt')]"
                      >
                      </vue-icon-base>
                    </div>
                    <div class="column">
                      <div
                        class="has-text-grey is-size-7"
                        v-text="$t('Require Two Wheeler')"
                      ></div>
                      <div
                        class="is-size-8 has-text-weight-bold"
                        v-text="
                          fetchedJobDetails.setting &&
                          fetchedJobDetails.setting.required_two_wheeler
                            ? $t('Yes')
                            : $t('No')
                        "
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    fetchedJobDetails.document_categories &&
                    fetchedJobDetails.document_categories.length
                  "
                  class="column is-6"
                >
                  <div
                    class="columns has-text-left is-vcentered pa-0 is-mobile"
                  >
                    <div class="column is-1 is-size-5 mr-2">
                      <vue-icon-base
                        height="16"
                        width="16"
                        :path="$options.icons[$kc('uni-file-alt')]"
                      >
                      </vue-icon-base>
                    </div>
                    <div class="column">
                      <div
                        class="is-size-7 has-text-grey"
                        v-text="$t('Supporting Documents')"
                      ></div>
                      <div class="has-text-weight-bold is-size-8">
                        <span
                          v-for="(document,
                          index) in fetchedJobDetails.document_categories"
                          :key="index"
                        >
                          {{ $t(document.name) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-12 py-0"><hr class="my-1" /></div>
                <div v-if="fetchedJobDetails.description" class="column is-12">
                  <div class="columns has-text-left pa-0 is-mobile">
                    <div class="column pr-2">
                      <vue-icon-base
                        height="16"
                        width="16"
                        :path="$options.icons[$kc('uni-list-ul')]"
                      >
                      </vue-icon-base>
                    </div>
                    <div class="column is-12">
                      <div
                        class="has-text-grey is-size-7"
                        v-text="$t('Job Description')"
                      ></div>
                      <div
                        class="is-size-8 has-text-weight-bold"
                        v-html="fetchedJobDetails.description"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <hr class="my-1" />
              </div>
            </div>
          </div>

          <div
            class="column card-footer is-12 pa-2 has-text-right is-hidden-mobile"
            :class="isShowDetail == true ? 'is-hidden-mobile' : ''"
          >
            <button
              class="button is-outlined is-employer"
              @click="gotoPreviousPage()"
              v-text="$t('Go Back')"
            ></button>
          </div>
        </div>
      </div>
      <div
        class="column is-3-desktop is-4-mobile py-0 mr-2 has-text-right is-hidden-desktop is-hidden-tablet is-pulled-right"
      >
        <button
          class="button is-outlined is-employer is-small"
          @click="viewDetail()"
        >
          <span v-text="$t('PreviewJob')" v-if="isShowDetail"></span>
          <span v-text="$t('Close Preview')" v-else class=""></span>
        </button>
      </div>
      <div class="column is-4">
        <confirm-job-post-new
          :jobdetail="fetchedJobDetails"
        ></confirm-job-post-new>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueIconBase from '@/components/Commons/VueIconBase'
import { getNameByValue } from '@/helpers/utils/filter'
import ConfirmJobPostNew from '@/components/Job/Post/Forms/ConfirmJobPostNew'
import { preferredShitChoices } from '@/helpers/constants/common'
import {
  jobLevelChoices,
  availableForChoices
} from '@/helpers/constants/jobseeker'
import {
  uniBriefcase,
  uniMapMarker,
  uniListUiAlt,
  uniListUl,
  uniClock,
  uniUsersAlt,
  uniFileCheck,
  uniMoneyBill,
  uniMars,
  uniSitemap,
  uniSmileBeam,
  uniFileAlt,
  uniCalendarAlt,
  uniEye,
  uniBusAlt,
  uniBookOpen,
  uniScience,
  uniUserCircle,
  uniBookReader,
  uniBag,
  uniMultiply,
  uniCalender
} from '@/helpers/icons'
export default {
  icons: {
    uniBriefcase,
    uniMapMarker,
    uniListUiAlt,
    uniListUl,
    uniFileAlt,
    uniMars,
    uniClock,
    uniBusAlt,
    uniSmileBeam,
    uniUsersAlt,
    uniFileCheck,
    uniMoneyBill,
    uniSitemap,
    uniCalendarAlt,
    uniEye,
    uniBookOpen,
    uniScience,
    uniUserCircle,
    uniBookReader,
    uniMultiply,
    uniBag,
    uniCalender
  },
  getNameByValue,
  preferredShitChoices,
  jobLevelChoices,
  availableForChoices,
  components: { VueIconBase, ConfirmJobPostNew },
  data() {
    return {
      isShowDetail: true,
      fetchedJobDetails: {}
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$axios
        .$get(`/api/v1/job/${this.$route.query.slug}/`)
        .then(response => {
          this.fetchedJobDetails = response
        })
    },
    viewDetail() {
      this.isShowDetail = !this.isShowDetail
    },
    gotoPreviousPage() {
      this.$router.push(
        this.localePath({
          name: 'job-post',
          query: {
            slug: this.$route.query.slug,
            step: '3'
          }
        })
      )
    }
  }
}
</script>
<style scoped>
.is-size-8 {
  font-size: 0.85rem;
}
.content-class {
  height: calc(100vh - 150px);
  overflow-y: auto;
}
@media only screen and (min-width: 769px) {
  .margin-left-60 {
    margin-left: -60px;
  }
  .margin-left-30 {
    margin-left: -30px;
  }
}
@media screen and (max-width: 400px) {
  .section {
    padding-bottom: 0px;
  }
}
.section {
  max-height: 65vh;
  overflow-y: scroll; /* Add the ability to scroll */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.section::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.section {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.container_width {
  width: 100%;
  margin: auto;
}
</style>
